import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Services", href: "/services" },
  { label: "Portfolio", href: "/portfolio" },
  { label: "Our Team", href: "/team" },
  { label: "Shop", href: "/shop" },
  { label: "Journal", href: "/blog" },
  { label: "Promotions", href: "/promotions" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-[#faf8f5] shadow-sm" : "bg-[#faf8f5]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/7727919c-5bf2-4e5d-8644-34d423ef05e8.png"
            alt="VegasGlamHair Logo"
            className="h-20 w-auto object-cover object-center"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium tracking-widest uppercase transition-colors duration-200 whitespace-nowrap ${
                scrolled
                  ? "text-neutral-700 hover:text-[#C9A96E]"
                  : "text-neutral-700 hover:text-[#C9A96E]"
              } ${location.pathname === link.href ? "text-[#C9A96E]" : ""}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Book Now CTA */}
        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/booking"
            className="bg-[#C9A96E] text-white text-sm font-semibold tracking-widest uppercase px-6 py-2.5 rounded-sm hover:bg-[#b8934f] transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Book Now
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer text-neutral-800"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-neutral-100 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-sm font-medium tracking-widest uppercase text-neutral-700 hover:text-[#C9A96E] transition-colors cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/booking"
            onClick={() => setMenuOpen(false)}
            className="bg-[#C9A96E] text-white text-sm font-semibold tracking-widest uppercase px-6 py-3 rounded-sm text-center hover:bg-[#b8934f] transition-colors cursor-pointer"
          >
            Book Now
          </Link>
        </div>
      )}
    </header>
  );
}
